<template>
  <component :is="route.meta.layout === 'main' ? MainLayout : AuthLayout" />
</template>

<script setup>
import MainLayout from '@app/layout/MainLayout.vue'
import AuthLayout from '@app/layout/AuthLayout.vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { onMounted } from 'vue'
const route = useRoute()

const { locale } = useI18n({ useScope: 'global' })

onMounted(() => {
  const language = localStorage.getItem('language') ?? 'en'
  locale.value = language
})
</script>
